<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent" :disabledInputList="variation.match ? disabledInputList : []">
    <div class="divider"><span>Atributos</span></div>

    <div class="l-row">
      <form-group :label="$t(`manufacturerReference.label`)" :columns="3" :error="getError('manufacturerReference', variation.sku)">
        <input class="form-input" type="text" v-model="variation.manufacturerReference" :disabled="disabledInputs()">
      </form-group>

      <form-group :label="$t(`crossDocking.label`)" :columns="3" :error="getError('crossDocking', variation.sku)">
        <input class="form-input" type="text" v-model="variation.crossDocking" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="variation.attributes.hasOwnProperty('color')" :label="$t(`color.label`)" :columns="3" :error="getError('attributes.color', variation.sku)" :required="false">
        <input class="form-input" type="text" v-model="variation.attributes.color" :disabled="disabledInputs()">
      </form-group>

      <form-group :required="true" :label="$t('gender.label')" :columns="3" :error="getError('gender', variation.sku)">
        <select v-model="variation.gender" class="form-select">
          <option :value="null">{{ $t('choose.label') }}</option>
          <option value="unisex">{{ $t('gender.unisex.label') }}</option>
          <option value="female">{{ $t('gender.female.label') }}</option>
          <option value="male">{{ $t('gender.male.label') }}</option>
        </select>
      </form-group>

      <form-group v-if="variation.attributes.hasOwnProperty('voltage')" :label="$t(`voltage.label`)" :columns="3" :error="getError('attributes.voltage', variation.sku)" :required="true">
        <select v-model="variation.attributes.voltage" v-html="options('flavor')" class="form-select" :disabled="disabledInputs()"></select>
      </form-group>

      <form-group v-if="variation.attributes.hasOwnProperty('size')" :label="$t(`size.label`)" :columns="3" :error="getError('attributes.size', variation.sku)" :required="true">
        <select v-model="variation.attributes.size" v-html="options('size')" class="form-select" :disabled="disabledInputs()"></select>
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      disabledInputList: [
        'ean',
        'weight',
        'height',
        'width',
        'length'
      ]
    }),
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error' || this.variation.match
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProvideVariation,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?e20d521e